import { getCssVariableValue } from './HelperUtils';
export var EColorPicker;
(function (EColorPicker) {
    EColorPicker["PINK"] = "EC4899";
    EColorPicker["CRIMSON"] = "F43F5E";
    EColorPicker["AMBER"] = "F59E0B";
    EColorPicker["LIME"] = "84CC16";
    EColorPicker["TEAL"] = "14B8A6";
    EColorPicker["LIGHT_BLUE"] = "0EA5E9";
    EColorPicker["INDIGO"] = "6366F1";
    EColorPicker["VIOLET"] = "6D3AF8";
    EColorPicker["ORANGE"] = "F97316";
    EColorPicker["EMERALD"] = "10B981";
    EColorPicker["CYAN"] = "06B6D4";
    EColorPicker["FUCHSIA"] = "D946EF";
    EColorPicker["RED"] = "EF4444";
    EColorPicker["YELLOW"] = "EAB308";
    EColorPicker["GREEN"] = "22C55E";
    EColorPicker["BLUE"] = "3B82F6";
})(EColorPicker || (EColorPicker = {}));
export const colorsHex = {
    '#5417CF': 'v',
    '#DB2777': 'p',
    '#E11D48': 'c',
    '#D97706': 'a',
    '#EA580C': 'o',
    '#65A30D': 'l',
    '#059669': 'e',
    '#0D9488': 't',
    '#0891B2': 'cy',
    '#0284C7': 'lb',
    '#4F46E5': 'i',
    '#C026D3': 'f',
    '#1D4DED': 'b'
};
export const colorDict = {
    EC4899: 'p',
    F43F5E: 'c',
    F59E0B: 'a',
    '84CC16': 'l',
    '14B8A6': 't',
    '0EA5E9': 'lb',
    '6366F1': 'i',
    '6D3AF8': 'v',
    F97316: 'o',
    '10B981': 'e',
    '06B6D4': 'cy',
    D946EF: 'f',
    EF4444: 'r',
    EAB308: 'y',
    '22C55E': 'g',
    '3B82F6': 'b',
    '1D4DED': 'b'
};
export const fullColorDict = {
    EC4899: 'Pink',
    F43F5E: 'Crimson',
    F59E0B: 'Amber',
    '84CC16': 'Lime',
    '14B8A6': 'Teal',
    '0EA5E9': 'Light Blue',
    '6366F1': 'Indigo',
    '6D3AF8': 'Violet',
    F97316: 'Orange',
    '10B981': 'Emerald',
    '06B6D4': 'Cyan',
    D946EF: 'Fuchsia',
    EF4444: 'Red',
    EAB308: 'Yellow',
    '22C55E': 'Green',
    '3B82F6': 'Blue'
};
export const getTailwindColorClass = ({ hexCode, classPrefix, shade = 700 }) => {
    let alias = 'n';
    if (hexCode && colorDict[hexCode]) {
        alias = colorDict[hexCode];
    }
    return `${classPrefix}-${alias}-${shade}`;
};
export const getColorName = ({ hexcode }) => {
    return fullColorDict[hexcode]?.toLowerCase() || '';
};
export const getTailwindTextColorClass = ({ hexCode, shade }) => {
    return getTailwindColorClass({ hexCode, classPrefix: 'text', shade });
};
export const getTailwindBgColorClass = ({ hexCode, shade = 100 }) => {
    return getTailwindColorClass({ hexCode, classPrefix: 'bg', shade });
};
export const getTailwindBorderColorClass = ({ hexCode, shade = 200 }) => {
    return getTailwindColorClass({ hexCode, classPrefix: 'border', shade });
};
export const getCSSVariable = ({ hexCode, shade = 700 }) => {
    const alias = hexCode ? colorDict[hexCode] : 'n';
    return getCssVariableValue(`--${alias}-${shade}`);
};
